import routes from "@/routers/routes";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type NavigationKey = keyof typeof navigations;

const navigations = {
  "1": "/",
  "2": routes.executive.dashboard,
  "3": routes.financial.dashboard,
  "4": routes.orders.dashboard,
  "5": routes.eCommerce.dashboard,
  "6": routes.analytics,
  "7": routes.support.dashboard,
  "8": routes.appointment.dashboard,
  "9": routes.jobBoard.dashboard,
  "0": routes.project.dashboard,
  q: routes.socialMedia.dashboard,
};

const allowedNumKeys = Object.keys(navigations);

export function useBoronKbdShortcuts() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (
        (event.metaKey || event.ctrlKey) &&
        allowedNumKeys.includes(event.key)
      ) {
        event.preventDefault();
        navigate(navigations[event.key as NavigationKey]);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
